// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs--2uAJ7","card_tab_navs":"card_tab_navs--3vr79"};